import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/updateFastShippingCopyMeganavSM/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { UPDATE_FAST_SHIPPING_COPY_MEGANAV_SM } from 'constants/TestTarget';

const showUpdateFastShippingCopyMeganavSMSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    control: testReady && experience === UPDATE_FAST_SHIPPING_COPY_MEGANAV_SM.CONTROL,
    challengerOne: testReady && experience === UPDATE_FAST_SHIPPING_COPY_MEGANAV_SM.CHALLENGER_ONE,
    challengerTwo: testReady && experience === UPDATE_FAST_SHIPPING_COPY_MEGANAV_SM.CHALLENGER_TWO,
    challengerThree: testReady && experience === UPDATE_FAST_SHIPPING_COPY_MEGANAV_SM.CHALLENGER_THREE
}));

export { showUpdateFastShippingCopyMeganavSMSelector };
